module.exports = __webpack_public_path__ + "docs/t&c-China.7bb8c66ada83d05d54c1be640fe619c5.html";